import { SidePanelPlacement } from 'features/side-panels/types';

export const getPanelHeight = (sidePanelPlacement: SidePanelPlacement, isMobile?: boolean) => {
  if (isMobile) {
    if (sidePanelPlacement === 'bottom') {
      return `calc(100% - var(--toolbar-width))`;
    }

    return '100%';
  }

  if (sidePanelPlacement === 'bottom') {
    return `calc(100% - var(--toolbar-width) - var(--topbar-height))`;
  }

  return `calc(100% - var(--topbar-height))`;
};
